<template>
    <div class="MailsData">
        <div class="titlePage">
            Reporte de Correos Ibero
            <div class="loadConf"><Config Module="MAILING" /></div>
        </div>
    <modal
      name="MailingModal"
      width="80%"
      height="auto"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      style="overflow:scroll"
    >
        <div v-if="renderComponent2" class="container">
            <div class="tabcontent">
                <div class="titlePageModal">Detalle del Correo:</div>
                <div class="zoneInfo">
                    <div class="row">
                        <div class="col-md-2"><strong>Enviado Por:</strong></div>
                        <div class="col-md-4">{{this.InfoModal.MailFrom}}</div>
                        <div class="col-md-2"><strong>Para:</strong></div>
                        <div class="col-md-4" v-html="valmails(this.InfoModal.MailTo)"></div>
                        <div class="col-md-2" v-if="this.InfoModal.MailCc"><strong>Cc:</strong></div>
                        <div class="col-md-4" v-if="this.InfoModal.MailCc" v-html="valmails(this.InfoModal.MailCc)"></div>
                        <div class="col-md-2"><strong>Estado:</strong></div>
                        <div class="col-md-4">
                            <span v-if="this.InfoModal.MailStatus === 1">En Cola</span>
                            <span v-else-if="this.InfoModal.MailStatus === 2">En Proceso</span>
                            <span v-else-if="this.InfoModal.MailStatus === 3">Enviado</span>
                            <span v-else-if="this.InfoModal.MailStatus === 4">Fallido</span>
                        </div>
                        <div class="col-md-2"><strong>Asunto:</strong></div>
                        <div class="col-md-4">{{this.InfoModal.MailSubject}}</div>
                        <div class="col-md-2"><strong>Fecha de Envio:</strong></div>
                        <div class="col-md-4">{{this.InfoModal.MailSend}}</div>
                        <div class="col-md-2" v-if="this.InfoModal.MailResponse"><strong>Detalle:</strong></div>
                        <div class="col-md-4" v-if="this.InfoModal.MailResponse">{{this.InfoModal.MailResponse}}</div>
                    </div>
                </div>
                <div class="titlePageModal" v-if="this.InfoModal.MailAttach">Adjuntos:</div>
                <div class="row zoneInfo" v-if="this.InfoModal.MailAttach">
                    <div v-for="item in this.InfoModal.MailAttach" :key="item.id" class="col-md-4">
                        <a :href="item.DetURI + item.NamFile" target="_blank">
                            <img class="imgdata ma-0" :id="item.AttachId" src="../../assets/images/pdfFile.png" alt="Archivo Adjunto" title="Archivo Adjunto" width="20" /> {{item.NamFile}}
                        </a>
                    </div>
                </div>
                <div class="titlePageModal">Correo Enviado:</div>
                <div v-html="this.InfoModal.MailBody" class="zoneInfo" />

            </div>
            <div class="botoPnrocess">
                <div class="container">
                    <div class="row">
                        <div class="col-md-3">
                            <button
                            id="UpdateMail"
                            type="submit"
                            v-on:click="SendMailMore()"
                            class="loginbtn primaryBtn"
                            >Reenviar</button>
                        </div>
                        <div class="col-md-6"></div>
                        <div class="col-md-3">
                            <button
                            id="CancelMail"
                            type="submit"
                            v-on:click="CancelModal"
                            class="loginbtn primaryBtn"
                            >Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </modal>
        <va-notification color="info" v-if="addRExito" class="refNoData">Se genero correctamente el reenvio del correo solicitado.</va-notification>
        <va-notification color="danger" v-if="refNoSend" class="refNoData">Se genero un fallo en el reenvio del correo solicitado.</va-notification>
        <div class="listData" v-if="noDtaForm">
            <DataList
                :InfoView="this.DLDataList"
                :HeadTable="this.HDDataList"
                :method="executeProcess"
                v-if="renderComponent1"
            />
        </div>
    </div>
</template>

<script>
import IberoHelpers from '@/store/helpers.js'
import DataList from '@/components/data-tables/DataReportMailing.vue'
import Config from '@/components/Configuration/Config.vue'

export default {
  name: 'MailsData',
  components: {
    DataList,
    Config,
  },
  data () {
    return {
      renderComponent1: false,
      renderComponent2: false,
      addRExito: false,
      refNoSend: false,
      DataList: [],
      InfoModal: [],
      HDDataList: [
        {
          name: 'MailId',
          title: 'Id',
          width: '10%',
        },
        {
          name: 'MailTo',
          title: 'Para',
          width: '20%',
        },
        {
          name: 'MailSubject',
          title: 'Asunto',
          width: '20%',
        },
        {
          name: 'MailSend',
          title: 'Fecha',
          width: '20%',
        },
        {
          name: '__slot:status',
          title: 'Estado',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: '__slot:attach',
          title: 'Detalle',
          dataClass: 'text-center',
          width: '10%',
        },
      ],
      DLDataList: [],
      noDtaForm: false,
    }
  },
  methods: {
    valmails (refMail) {
      return refMail.replace(/,/g, '<br>')
    },
    CancelModal () {
      this.$modal.hide('MailingModal')
    },
    SendMailMore () {
      let message = {
        title: 'Reenviar Correo Ibero',
        body: '¿ Se realizará el reenvio del correo electronico seleccionado, está seguro de realizar esta actualización ?',
      }
      let options = {
        okText: 'Continuar',
        cancelText: 'Cerrar',
      }
      this.$dialog.confirm(message, options).then(dialog => {
        this.SendMailData()
      })
    },
    SendMailData () {
      this.CancelModal()
      this.renderComponent2 = false
      let loader = this.$loading.show()
      var sendMails = IberoHelpers.sendMailbyId(this.$store, this.InfoModal.MailId)
      sendMails.then(Response => {
        if (Response.data) {
          this.loadMailist()
          this.addRExito = true
        } else {
          this.refNoSend = false
        }
        loader.hide()
      })
    },
    loadMailist () {
      this.addRExito = false
      this.refNoSend = false
      this.renderComponent1 = false
      let loader = this.$loading.show()
      var datMails = IberoHelpers.getMailsData(this.$store)
      datMails.then(Response => {
        if (Response.data) {
          this.DLDataList = Response.data
          this.noDtaForm = true
          IberoHelpers.forceRerender1(this)
        } else {
          this.noDtaForm = false
        }
        loader.hide()
      })
    },
    executeProcess: function (event, refer) {
      this.renderComponent2 = false
      this.CancelModal()
      this.InfoModal = event.rowData
      IberoHelpers.forceRerender2(this)
      this.$modal.show('MailingModal')
    },
  },
  created: function () {
    this.loadMailist()
  },
}
</script>

<style scoped>
/* STYLING */
.container {
  margin: 10px auto;
  font-family: "Montserrat", sans-serif;
  color: #888;
}

.botoPnrocess {
  text-align: center;
  margin-top: -10px;
  margin-bottom: 30px;
}

.tabcontent {
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-shadow: 3px 3px 6px #e1e1e1;
  overflow-y: scroll;
  height: 700px;
}

.titlePageModal {
    color: #F65A6F;
    font-weight: bold;
    font-size: 10px;
    text-transform: uppercase;
    border-style: solid;
    border-color: #F65A6F;
    border-bottom-width: 2px;
    padding-bottom: 10px;
    margin-bottom: 10px;
}

.zoneInfo {
    margin-top: 20px;
    margin-bottom: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.zoneInfo a {
    color: #a2273c !important;
}

.loadConf{
    float: right;
}
</style>